import styled from 'styled-components';

export const ChangesWrapper = styled.div`
    display: flex;
    position: relative;
`;

export const TimelineSidebar = styled.div`
    position: relative;
    width: 63px;
    flex-shrink: 0;

    /* Timeline vertical line */
    &::before {
        content: '';
        position: absolute;
        left: 50%;
        top: -42px;
        bottom: 77px;
        width: 2px;
        background: #ccc;
        border-radius: 2px;
    }

    /* Timeline dots */
    .timeline-dot {
        position: absolute;
        left: 51%;
        transform: translateX(-50%);
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #ccc;
        box-shadow: 0 0 0 5px #fff;
        transition: all 0.2s ease;
        &.timeline-dot-start {
            width: 12.7px;
            top: -59px;
            border-radius: 0;
        }
        &:not(.timeline-dot-start) :hover {
            transform: translateX(-50%) scale(1.2);
            background: #53ac39;
            filter: blur(2px);
        }
    }
`;

export const TableWrapper = styled.div`
    flex: 1;
    min-width: 0;
    [data-testid='ids-table-change-log-in-all-versions-table'] {
        /* For expanded rows */
        .ant-table-expanded-row > td:first-child {
            border-left: none !important;
        }
    }
`;
